import { createContext, useState } from 'react';
import * as React from 'react';

interface ICommonContext {
  showMenu: boolean;
  setShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CommonContext = createContext<ICommonContext>({
  showMenu: false,
  setShowMenu: (value: any) => undefined,
});

export const CommonContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <CommonContext.Provider
      value={{
        showMenu,
        setShowMenu,
      }}
    >
      {children}
    </CommonContext.Provider>
  );
};
